import { render, staticRenderFns } from "./ParentConfigDialog.vue?vue&type=template&id=37cacf46&scoped=true"
import script from "./ParentConfigDialog.vue?vue&type=script&lang=js"
export * from "./ParentConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./ParentConfigDialog.vue?vue&type=style&index=0&id=37cacf46&prod&scoped=true&lang=css"
import style1 from "./ParentConfigDialog.vue?vue&type=style&index=1&id=37cacf46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cacf46",
  null
  
)

export default component.exports